import React, { useState } from "react";
import SideBar from "../SideBar/SideBar";
import Footer from "../Footer/Footer";
import "./Settings.css";
import { LockIcon } from "lucide-react";
import Header from "../Header/Header";
const Settings = () => {
  const [bannerActive, setBannerActive] = useState(false);

  return (
    <div>
      <SideBar />
      <Header value={{ name: "Settings" }} />
      <div className="settings-page   ">
        <h1 className="settings-title">Support Banner</h1>

        <div className="settings-card">
          <div className="settings-header">
            <h4>Show Your Support</h4>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={bannerActive}
                onChange={() => setBannerActive(!bannerActive)}
              />
              <span className="slider"></span>
            </label>
          </div>

          <div className="settings-text">
            <p>
              Show your support for important causes with a profile banner. Only
              one banner can be active at a time.
            </p>
          </div>
        </div>
        <h1 className="settings-title mt-3">Support Banner</h1>
        <div className="settings-card ">
          <div className="settings-header ">
            <h4>Email sign-up</h4>
            <label className="toggle-switch">
              <LockIcon />
            </label>
          </div>

          <div className="settings-text">
            <p>
              Add an email sign-up field to your QFlyer so visitors can join
              your mailing list.
            </p>
          </div>
        </div>
        <div className="settings-card mt-2">
          <div className="settings-header ">
            <h4>SMS sign-up</h4>
            <label className="toggle-switch">
              <LockIcon />
            </label>
          </div>

          <div className="settings-text">
            <p>Collect SMS subscribers with a sign-up field on your QFlyer.</p>
          </div>
        </div>

        <h1 className="settings-title mt-3">Shop</h1>
        <div className="settings-card ">
          <div className="settings-header ">
            <h4>Display Shop</h4>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={bannerActive}
                onChange={() => setBannerActive(!bannerActive)}
              />
              <span className="slider"></span>
            </label>
          </div>

          <div className="settings-text">
            <p>Have your Shop tab visible on your Linktree.</p>
          </div>
        </div>
        <div className="settings-card mt-2">
          <div className="settings-header ">
            <h4>Set Shop as main tab</h4>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={bannerActive}
                onChange={() => setBannerActive(!bannerActive)}
              />
              <span className="slider"></span>
            </label>
          </div>

          <div className="settings-text">
            <p>Have your Shop tab visible on your Linktree.</p>
          </div>
        </div>
        <div className="settings-card mt-2">
          <div className="settings-header ">
            <h4>Preview Shop on Links page</h4>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={bannerActive}
                onChange={() => setBannerActive(!bannerActive)}
              />
              <span className="slider"></span>
            </label>
          </div>

          <div className="settings-text">
            <p>Have your Shop tab visible on your Linktree.</p>
          </div>
        </div>

        <h1 className="settings-title mt-3">Sensitive material</h1>
        <div className="settings-card ">
          <div className="settings-header ">
            <h4>Sensitive material</h4>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={bannerActive}
                onChange={() => setBannerActive(!bannerActive)}
              />
              <span className="slider"></span>
            </label>
          </div>
          <div className="settings-text">
            <p>Collect SMS subscribers with a sign-up field on your QFlyer.</p>
          </div>
        </div>

        <h1 className="settings-title mt-3">SEO</h1>
        <div className="settings-card ">
          <div className="settings-header ">
            <h4>Custom metadata</h4>
            <label className="toggle-switch">
              <LockIcon />
            </label>
          </div>
          <div className="settings-text">
            <p>
              Changes to metadata may take some time to appear on other
              platforms.
            </p>
          </div>
          <div className="input-seo">
            <input className="p-3 " placeholder="Meta title" />
            <input className="p-3 " placeholder="Meta title" />
          </div>
        </div>

        <h1 className="settings-title mt-3">Subscribe</h1>
        <div className="settings-card ">
          <div className="settings-header ">
            <h4>Let visitors subscribe</h4>
            <label className="toggle-switch">
              <LockIcon />
            </label>
          </div>

          <div className="settings-text">
            <p>Add a button so visitors can subscribe to Qflyer</p>
          </div>
        </div>

        <h1 className="settings-title mt-3">QR </h1>
        <div className="settings-card ">
          <div className="settings-header ">
            <h4>Manage your subscription, billing, and payment settings.</h4>
            <label className="btn-qr-cont">
              <button className="btn-qr">OR Settings</button>
            </label>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Settings;
